export class ListEvents {
    static get arbetsorderListLength(): string { return "productionplanning_list_arbetsorderListLength"; }
    static get mouseOverArbetsorder(): string { return "productionplanning_list_mouseOverArbetsorder"; }
    static get mouseOverAtgard(): string { return "productionplanning_list_mouseOverAtgard"; }
    static get aoHeaderSelect(): string { return "productionplanning_list_ao_header_select"; }
    static get select(): string { return "productionplanning_list_select"; }
    static get selectAll(): string { return "productionplanning_list_selectAll"; }
}
